"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var settle = require("axios/lib/core/settle");
var buildURL = require("axios/lib/helpers/buildURL");
var isURLSameOrigin = require("axios/lib/helpers/isURLSameOrigin");
var createError = require("axios/lib/core/createError");
var utils = require("axios/lib/utils");
function fetchAdapter(config) {
    return new Promise(function dispatchFetchRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        if (utils.isFormData(requestData)) {
            delete requestHeaders['Content-Type']; // Let the browser set it
        }
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password || '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if (utils.isStandardBrowserEnv()) {
            var cookies = require('axios/lib/helpers/cookies');
            // Add xsrf header
            var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) &&
                config.xsrfCookieName
                ? cookies.read(config.xsrfCookieName)
                : undefined;
            if (xsrfValue && config.xsrfHeaderName) {
                requestHeaders[config.xsrfHeaderName] = xsrfValue;
            }
        }
        fetch(buildURL(config.url, config.params, config.paramsSerializer), {
            method: config.method,
            headers: requestHeaders,
            // @ts-ignore
            withCredentials: config.withCredentials ? 'same-origin' : 'omit',
        }).then(handleSuccess, handleError);
        function handleSuccess(resp) {
            // Prepare the response
            resp.text().then(function (responseData) {
                var response = {
                    data: responseData,
                    status: resp.status,
                    statusText: resp.statusText,
                    headers: resp.headers,
                    config: config,
                };
                settle(resolve, reject, response);
            });
        }
        // Handle low level network errors
        function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(createError('Network Error', config, null));
        }
        // Handle timeout
        // request.ontimeout = function handleTimeout() {
        //   reject(
        //     createError(
        //       'timeout of ' + config.timeout + 'ms exceeded',
        //       config,
        //       'ECONNABORTED',
        //       // request,
        //     ),
        //   );
        // };
        // // Handle progress if needed
        // if (typeof config.onDownloadProgress === 'function') {
        //   request.addEventListener('progress', config.onDownloadProgress);
        // }
        // // Not all browsers support upload events
        // if (typeof config.onUploadProgress === 'function' && request.upload) {
        //   request.upload.addEventListener('progress', config.onUploadProgress);
        // }
        // if (config.cancelToken) {
        //   // Handle cancellation
        //   config.cancelToken.promise.then(function onCanceled(cancel) {
        //     if (!request) {
        //       return;
        //     }
        //     request.abort();
        //     reject(cancel);
        //     // Clean up request
        //     request = null;
        //   });
        // }
        // if (requestData === undefined) {
        //   requestData = null;
        // }
    });
}
exports.fetchAdapter = fetchAdapter;
//# sourceMappingURL=axios-fetch-adapter.js.map